import axios from 'axios';
import BASE_URL from "./config"; // Adjust the path as needed

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (token) {
      prom.resolve(token);
    } else {
      prom.reject(error);
    }
  });

  failedQueue = [];
};

// Axios Response Interceptor to handle 401 errors (token expired)
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const refreshToken = localStorage.getItem('refreshToken');

    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      if (!refreshToken || refreshToken === "null") {
        return Promise.reject(error); // No refresh token, force login
      }

      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        }).then((token) => {
          originalRequest.headers['Authorization'] = `Bearer ${token}`;
          return axiosInstance(originalRequest);
        });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      return new Promise(async (resolve, reject) => {
        try {
          const newToken = await refreshAccessToken(refreshToken);

          localStorage.setItem('token', newToken); // Save new token
          axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
          originalRequest.headers['Authorization'] = `Bearer ${newToken}`;

          processQueue(null, newToken);
          resolve(axiosInstance(originalRequest));
        } catch (err) {
          processQueue(err, null);
          reject(err);
        } finally {
          isRefreshing = false;
        }
      });
    }

    return Promise.reject(error);
  }
);

// Function to refresh access token
async function refreshAccessToken(refreshToken) {
  try {
    const response = await axios.post(`${BASE_URL}/Auth/refresh`, { token: refreshToken });
    return response.data.accessToken; // Return the new access token
  } catch (error) {
    console.error('Error refreshing access token:', error);
    throw error;
  }
}

export default axiosInstance;
